<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
        <v-card flat class="mb-4">
          <v-card-title class="subheading font-weight-bold justify-left">
            Thông tin sản phẩm
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="7">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Tên sản phẩm:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.ten}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.loaiDongVat">
                    <v-list-item-content class="font-weight-medium">Nhóm sản phẩm:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.loaiDongVat.tenLoaiDongVat}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.moiTruongSong">
                    <v-list-item-content class="font-weight-medium">Phân nhóm:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.moiTruongSong.tenMoiTruongSong}}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="5"
              >
                <v-img
                  v-if="item.hinhVatNuoi"
                  contain
                  width="250"
                  :src="`${config.agriDataBackUrl}/file-download/file/${item.hinhVatNuoi.filename}`"
                  class="mx-auto"
                />
                <v-img
                  v-else
                  contain
                  src="@/assets/dac-san-chan-nuoi-logo.jpg"
                  class="mx-auto"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-text>
                <v-tabs
                  color="primary"
                  centered
                  class="rounded-t-lg"
                  background-color="primary"
                  dark
                >
                  <v-tab>Mô tả sản phẩm</v-tab>
                  <v-tab>Tổng đàn vật nuôi</v-tab>

                  <v-tab-item class="pt-4">
                    <v-row v-if="item.moTa">
                      <v-col cols="12">
                        <div v-html="item.moTa"/>
                      </v-col>
                    </v-row>
                    <span v-else>
                      Không tìm thấy dữ liệu
                    </span>
                  </v-tab-item>

                  <v-tab-item class="pt-4">
                    <v-row v-if="item.tinhHinhChanNuoiTongQuan">
                      <v-col cols="12">
                        <div v-html="item.tinhHinhChanNuoiTongQuan"/>
                      </v-col>
                    </v-row>
                    <span v-else>
                      Không tìm thấy dữ liệu
                    </span>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        sm="12"
        md="4"
      >
        <v-card flat height="100%">
          <v-card flat class="text-center"
            :loading="relatedLoading"
          >
            <v-card-text>
              <span class="text-h6 font-weight-bold">
                Các sản phẩm khác
              </span> 
            </v-card-text>
          </v-card>
          <v-card 
            v-if="relatedItems.length == 0"
            flat 
            class="text-center"
          >
            <v-card-text>
              <span>
                Chưa tìm thấy sản phẩm phù hợp
              </span>
            </v-card-text>
          </v-card>
          <v-card flat 
            v-for="(related_item, index) in relatedItems"
            :to="{ name: 'AnimalProductTrace', params: { id: related_item.id }}"
            :key="index"
            class="px-6"
          >
            <div class="d-flex flex-no-wrap">
              <v-avatar
                class="ma-3 rounded-lg"
                size="100"
                tile
              >
                <v-img 
                  v-if="related_item.hinhVatNuoi"
                  :src="`${config.agriDataBackUrl}/file-download/file/${related_item.hinhVatNuoi.filename}`"
                />
                <v-img 
                  v-else
                  src="@/assets/dac-san-chan-nuoi-logo.jpg"
                />
              </v-avatar>
              <div>
                <v-card-title class="text-h6">
                  {{related_item.ten}}
                </v-card-title>
                <v-card-subtitle>
                  Thuộc nhóm: 
                  <span v-if="related_item.moiTruongSong">
                    {{related_item.moiTruongSong.tenMoiTruongSong}}
                  </span>
                </v-card-subtitle>
              </div>
            </div>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import moment from 'moment';
  import { mapState, mapActions } from 'vuex';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import SystemSevice from '@/services/System';
  export default {
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      crumbs: [],
      item: {},
      relatedItems: [],
      tongDanVatNuois_show: true,
      tongDanVatNuois: [],
      headers: [
        { text: 'Vùng nuôi'},
        { text: 'Số lượng', align: 'center'}
      ],
      relatedLoading: false,
    }),
    watch: {
      "$route.params.id": function() {
        this.getProductDetail();
        this.getRelatedItems();
        this.scrollToTop();
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted() {
      this.getProductDetail();
      this.getRelatedItems();
      SystemSevice.setSiteViewLocal({
        name: `AnimalProductTrace@${this.$route.params.id}`,
      });
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      getProductDetail(){
        const app = this;
        const url = 'api/v1/public/get-animal-special-prod-detail';
        app.getLoader(true);
        axios.get(`${url}/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            // app.getTotalAnimal(app.item.id);
            app.crumbs = [
              {
                text: 'Sản phẩm đặc sản',
                disabled: false,
                href: '/products/special/animal',
              },
              {
                text: app.item.ten,
                disabled: true
              }
            ];
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getTotalAnimal(id){
        axios.get(`api/v1/public/get-total-animal/${id}`)
          .then(response => {
            this.tongDanVatNuois = response.data.content;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getRelatedItems(){
        const app = this;
        app.relatedLoading = true;
        axios.get(`api/v1/public/products-related/channuoi/${app.$route.params.id}`)
          .then(response => {
            app.relatedItems = response.data;
            app.relatedLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            app.relatedLoading = false;
          });
      },
      format_date(value){
        if (value) {
          return moment(String(value)).format('DD-MM-YYYY');
        }
      },
      scrollToTop() {
        window.scrollTo(0,0);
      }
    }
  }
</script>

<style>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),
      0 0 0 0 rgba(0,0,0,.14),
      0 0 0 0 rgba(0,0,0,.12) !important;
  }
</style>